import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseImporterSelectors = importerSelectors(
  'course.importer',
)

export default courseImporterSelectors
